import React from "react";
import Header from "../components/Header/Header";
import Navbar from "../components/Navbar/Navbar";

const OrganizingDept = () => {
  return (
    <div>
      <Header />
      <Navbar />
      <div className="max-w-7xl mx-auto px-2 py-8 border-t-2 border-gray-300">
        {/* Title */}
        <h1 className="text-3xl md:text-4xl mb-10">
          Organizing Department of MNNIT Allahabad
        </h1>

        {/* Subheading */}
        <h2 className="text-2xl md:text-3xl mb-4">Department of Biotechnology</h2>

        {/* Description */}
        <p className="text-gray-700 mb-4 leading-relaxed">
          Biotechnology at MNNIT Allahabad was established as a new academic
          unit under Applied Mechanics in 2006, aiming to integrate life
          sciences with engineering and develop cutting-edge technology through
          research, training, and technological innovation. The Independent
          Department of Biotechnology was established in April 2012. Since its
          inception, the department has witnessed a consistent rise in
          student&apos;s demand for the subject. Keeping a beat to the global
          demands for researchers in this field, a full-fledged postgraduate
          degree course (M. Tech) in Biotechnology was introduced in 2010. The
          department has also started a PhD program in biotechnology since 2009.
        </p>

        <p className="text-gray-700 mb-4 leading-relaxed">
          The department is equipped with all the necessary instruments and
          several research facilities. The department has a young and
          enthusiastic faculty that is actively involved in research and
          teaching. Presently, the B. Tech, M. Tech, and PhD programs in
          biotechnology are being run with the involvement of fifteen faculty
          members.
        </p>

        {/* Link Section */}
        <p className="text-gray-700 font-medium">
          To find the details of faculty members, please click this link:{" "}
          <a
            href="https://www.mnnit.ac.in/index.php/department/engineering/biotech/biotechfp"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 hover:underline"
          >
            https://www.mnnit.ac.in/index.php/department/engineering/biotech/biotechfp
          </a>
        </p>
      </div>
    </div>
  );
};

export default OrganizingDept;
